import { JoyField, JoyObjectType, JoyDataService, JoyDataServiceQueryOption, isStringArray, } from 'joy-core';
import JoyDeal from '../objects/JoyDeal';
export default class JoyCrmUserHelper {
    /**
     * Fetch the Deal documents that this user belongs to..
     * @param count Maximum number of documents to retrieve, 0 means all.
     * @param userId Identifier of the user that can access the deals.
     * @param dealIds Array of identifiers to filter deals.
     */
    static async getDeals(userId, dealIds, count = 0) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.group;
        data[JoyField.user] = userId;
        if (isStringArray(dealIds)) {
            let allDeals = [];
            let chunkSize = 10;
            let i = 0, j = 0;
            for (i = 0, j = dealIds.length; i < j; i += chunkSize) {
                let chunk = dealIds.slice(i, i + chunkSize);
                data[JoyField.deals] = chunk;
                let dealsData = await JoyDataService.instance.read(data, new Map());
                for (const dealData of dealsData) {
                    try {
                        allDeals.push(new JoyDeal(dealData));
                    }
                    catch (error) {
                        throw Error('Invalid input for JoyDeal.');
                    }
                }
                if (count > 0 && allDeals.length >= count) {
                    return allDeals.slice(0, count);
                }
            }
            return allDeals;
        }
        else {
            let options = new Map();
            options[JoyDataServiceQueryOption.limit] = count;
            let result = await JoyDataService.instance.read(data, options);
            let deals = [];
            for (const data of result) {
                try {
                    deals.push(new JoyDeal(data));
                }
                catch (error) {
                    throw Error('Invalid input for JoyDeal.');
                }
            }
            return deals;
        }
    }
}
//# sourceMappingURL=JoyCrmUserHelper.js.map